import { LftTypography } from '@lift/design-system-react-web/dist/components';
import S from './course-info.styles';
import { CourseInfoProps } from './course-info.types';

export const CourseInfo: React.FC<CourseInfoProps> = ({ courseType, courseName }) => {
  return (
    <S.Container id="course-info">
      <LftTypography component="caption" size="small" bgColor dataTestId="course-type">
        {courseType && `${courseType}:`}
      </LftTypography>
      <LftTypography component="paragraph" size="small" fontWeight="bold" bgColor dataTestId="course-name">
        {courseName}
      </LftTypography>
    </S.Container>
  );
};
